<div
  class="relative flex h-screen min-w-0 flex-col overflow-hidden rounded-none bg-gray-50 shadow-xl md:h-[90vh] md:flex-row md:rounded-2xl"
>
  <aside
    [class.hidden]="!isMobileMenuOpen"
    class="absolute inset-y-0 left-0 z-50 flex w-64 flex-shrink-0 flex-col border-r bg-white transition-all md:relative md:flex md:translate-x-0"
    [ngClass]="isMobileMenuOpen ? 'translate-x-0 shadow-2xl' : '-translate-x-full md:translate-x-0'"
  >
    <div class="flex items-center justify-between border-b p-6">
      <h2 class="text-xs font-bold uppercase tracking-wider text-gray-400">Entidades del Sistema</h2>
      <button mat-icon-button class="md:hidden" (click)="isMobileMenuOpen = false">
        <mat-icon>close</mat-icon>
      </button>
    </div>

    <div class="px-6 py-4">
      <div class="relative">
        <mat-icon class="absolute left-3 top-1/2 -translate-y-1/2 text-sm text-gray-400">search</mat-icon>
        <input
          type="text"
          placeholder="Buscar entidad..."
          [formControl]="searchControl"
          class="w-full rounded-lg border-none bg-gray-100 py-2 pl-9 pr-4 text-sm outline-none focus:ring-2 focus:ring-primary/20"
        />
      </div>
    </div>

    <nav class="flex-auto space-y-1 overflow-y-auto p-4">
      <button
        *ngFor="let entity of filteredEntities$ | async"
        (click)="onEntitySelect(entity); isMobileMenuOpen = false"
        [class.bg-blue-50]="entities[selectedEntityIndex] === entity"
        [class.text-blue-700]="entities[selectedEntityIndex] === entity"
        class="group flex w-full items-center justify-between rounded-xl px-4 py-3 transition-all hover:bg-gray-100"
      >
        <div class="flex items-center gap-3">
          <mat-icon [class.text-blue-600]="entities[selectedEntityIndex] === entity" class="text-gray-400"
            >layers</mat-icon
          >
          <span class="text-sm font-medium">{{ getEntityLabel(entity) }}</span>
        </div>
        <div *ngIf="entities[selectedEntityIndex] === entity" class="h-2 w-2 rounded-full bg-blue-600"></div>
      </button>
    </nav>
  </aside>

  <div
    *ngIf="isMobileMenuOpen"
    (click)="isMobileMenuOpen = false"
    class="fixed inset-0 z-40 bg-black/20 md:hidden"
  ></div>

  <main class="flex min-w-0 flex-auto flex-col overflow-hidden">
    <header
      class="z-10 flex flex-col items-start justify-between gap-4 border-b bg-white p-4 shadow-sm md:p-6 lg:flex-row lg:items-center"
    >
      <div class="flex w-full items-center gap-3 lg:w-auto">
        <button mat-icon-button class="-ml-2 md:hidden" (click)="toggleMobileMenu()">
          <mat-icon>menu</mat-icon>
        </button>

        <div class="flex flex-col">
          <div class="mb-1 flex items-center gap-2 text-xs text-gray-400">
            <span>Catálogo</span>
            <mat-icon class="h-3 w-3 text-[12px]">chevron_right</mat-icon>
            <span class="font-medium text-blue-600">{{ getEntityLabel(entities[selectedEntityIndex]) }}</span>
          </div>
          <h1 class="text-xl font-bold text-gray-800 md:text-2xl">Gestión de Campos</h1>
        </div>
      </div>

      <div class="flex w-full items-center gap-2 md:gap-4 lg:w-auto">
        <div
          class="flex h-[50px] flex-1 items-center md:min-w-[370px]"
          [formGroup]="formConfigs[entities[selectedEntityIndex]][selectedAction]"
        >
          <app-toggle-option
            title="Uso Exclusivo de la APP"
            icon="smartphone"
            formControlName="applyOnlyApp"
            class="h-full w-full"
          >
          </app-toggle-option>
        </div>
        <button mat-icon-button (click)="dialogRef.close()" class="shrink-0 border bg-white shadow-sm">
          <mat-icon>close</mat-icon>
        </button>
      </div>
    </header>

    <div class="flex-auto overflow-y-auto bg-gray-50/50 p-4 md:p-8">
      <div
        class="mx-auto max-w-6xl overflow-hidden rounded-2xl border border-gray-100 bg-white shadow-sm md:rounded-3xl"
      >
        <div class="flex flex-col items-start justify-between gap-4 border-b p-4 md:p-6 xl:flex-row xl:items-center">
          <div class="flex w-full flex-col items-start gap-4 sm:flex-row sm:items-center xl:w-auto">
            <h3 class="font-bold text-gray-700">Campos</h3>
            <div class="flex w-full rounded-xl bg-gray-100 p-1 sm:w-auto">
              <button
                (click)="onActionChange(0)"
                [class.bg-white]="selectedAction === 'Create'"
                class="flex-1 rounded-lg py-2 text-sm font-medium transition-all sm:px-6"
              >
                Creación
              </button>
              <button
                (click)="onActionChange(1)"
                [class.bg-white]="selectedAction === 'Update'"
                class="flex-1 rounded-lg py-2 text-sm font-medium transition-all sm:px-6"
              >
                Edición
              </button>
            </div>
          </div>

          <div class="flex w-full gap-2 xl:w-auto">
            <button
              mat-stroked-button
              color="primary"
              class="flex-1 rounded-xl py-6"
              (click)="manageGroups()"
            >
              <mat-icon>workspaces</mat-icon> <span class="hidden sm:inline">Grupos</span>
            </button>
            <button
              mat-flat-button
              color="primary"
              class="flex-1 rounded-xl py-6"
              (click)="addNewField()"
            >
              <mat-icon>add</mat-icon> <span class="hidden sm:inline">Nuevo</span>
            </button>
          </div>
        </div>

        <div
          *ngIf="showBusinessPartnerEditFieldsLegend"
          class="mx-4 flex items-start gap-3 border-b border-blue-100 bg-blue-50 px-4 py-3 md:mx-6 md:px-6"
        >
          <mat-icon class="shrink-0 text-blue-600">info</mat-icon>
          <p class="m-0 text-sm text-blue-800">
            Solo los campos configurados en esta lista están habilitados para edición desde la aplicación.
          </p>
        </div>

        <div class="overflow-x-auto p-0">
          <app-smart-grid [data]="gridData" [columnDefs]="columnDefs" [config]="gridConfig" [loading]="false">
          </app-smart-grid>
        </div>
      </div>
    </div>
  </main>

  <ng-template #addModal>
    <div class="flex h-full flex-col overflow-hidden">
      <div class="flex items-center justify-between border-b bg-white p-6">
        <h2 class="text-xl font-bold tracking-tight">Configurar Propiedades del Campo</h2>
        <button mat-icon-button (click)="closeEditModal()"><mat-icon>close</mat-icon></button>
      </div>

      <mat-dialog-content class="flex-auto overflow-y-auto bg-gray-50 p-6">
        <ng-container [formGroup]="formConfigs[entities[selectedEntityIndex]][selectedAction]">
          <div formArrayName="fields">
            <div
              *ngFor="let fieldGroup of getFieldControls(entities[selectedEntityIndex], selectedAction); let i = index"
            >
              <div
                *ngIf="i === editingFieldIndex"
                [formGroupName]="i"
                class="mb-4 flex flex-col gap-6"
              >
                <div class="flex items-center justify-between">
                  <span class="rounded-full bg-blue-50 px-4 py-1 text-xs font-bold uppercase text-blue-700">
                    Propiedades del Campo #{{ i + 1 }}
                  </span>
                  <button
                    mat-icon-button
                    color="warn"
                    class="bg-red-50"
                    (click)="deleteField(i)"
                    matTooltip="Eliminar campo"
                  >
                    <mat-icon>delete_outline</mat-icon>
                  </button>
                </div>

                <app-form-section
                  title="Campo de usuario"
                  icon="person"
                  iconColor="blue"
                  contentClass="flex flex-col gap-4"
                >
                  <app-toggle-option
                    title="¿Es Campo de Usuario?"
                    icon="person"
                    iconColor="blue"
                    formControlName="isUserField"
                  ></app-toggle-option>

                  <div *ngIf="fieldGroup.get('isUserField').value" class="grid grid-cols-1 gap-4 sm:grid-cols-2">
                    <mat-form-field class="w-full">
                      <mat-label>Categoría</mat-label>
                      <mat-select
                        formControlName="userFieldEntity"
                        (selectionChange)="loadAllUsersFields($event.value)"
                      >
                        <mat-option *ngFor="let opt of userEntityList" [value]="opt.value">{{ opt.label }}</mat-option>
                      </mat-select>
                    </mat-form-field>
                    <div class="flex w-full gap-2">
                      <mat-form-field class="min-w-0 flex-auto w-full">
                        <mat-label>Seleccionar Campo</mat-label>
                        <mat-select formControlName="userField">
                          <mat-option *ngFor="let uf of userFieldsConfig" [value]="uf.fieldName">
                            {{ uf.fieldLabel?.master }} ({{ uf.fieldName }})
                          </mat-option>
                        </mat-select>
                      </mat-form-field>
                      <button
                        mat-mini-fab
                        color="primary"
                        class="mt-2 shrink-0"
                        (click)="syncField(fieldGroup)"
                      >
                        <mat-icon>sync</mat-icon>
                      </button>
                    </div>
                  </div>
                </app-form-section>

                <app-form-section
                  title="Información general"
                  icon="storage"
                  iconColor="blue"
                  contentClass="grid grid-cols-1 gap-4 sm:grid-cols-2 md:grid-cols-3"
                >
                  <mat-form-field class="w-full">
                    <mat-label>Nombre Campo (DB)</mat-label>
                    <input matInput formControlName="name" />
                    <mat-error *ngIf="fieldGroup.get('name').hasError('duplicateName')">Nombre duplicado</mat-error>
                    <mat-error *ngIf="fieldGroup.get('name').hasError('required')">El nombre es requerido.</mat-error>
                  </mat-form-field>

                  <div class="flex w-full min-w-0 gap-2">
                    <mat-form-field class="min-w-0 flex-auto w-full">
                      <mat-label>Tipo de Dato</mat-label>
                      <mat-select formControlName="type">
                        <mat-option *ngFor="let opt of fieldTypeOptions" [value]="opt.value">{{ opt.label }}</mat-option>
                      </mat-select>
                    </mat-form-field>
                    <ng-container
                      *ngIf="['select', 'multiselect', 'form', 'attachment'].includes(fieldGroup.get('type').value)"
                    >
                      <button
                        mat-mini-fab
                        color="primary"
                        type="button"
                        class="mt-2 shrink-0"
                        [disabled]="isConfigButtonDisabledBySchema(fieldGroup)"
                        [matTooltip]="isConfigButtonDisabledBySchema(fieldGroup) ? 'Los valores se cargan desde el Schema configurado' : ''"
                        (click)="openValuesModal(fieldGroup)"
                      >
                        <mat-icon>settings</mat-icon>
                      </button>
                    </ng-container>
                  </div>
                  <mat-form-field class="w-full min-w-0">
                    <mat-label>Etiqueta Visible (UI)</mat-label>
                    <input matInput formControlName="label" />
                    <mat-error *ngIf="fieldGroup.get('label').hasError('required')">La etiqueta es requerida.</mat-error>
                  </mat-form-field>
                </app-form-section>

                <app-form-section
                  title="Agrupación"
                  icon="workspaces"
                  iconColor="purple"
                  contentClass="grid grid-cols-1 gap-4 sm:grid-cols-10"
                >
                  <mat-form-field class="w-full sm:col-span-7">
                    <mat-label>Grupo</mat-label>
                    <mat-select formControlName="groupId" (selectionChange)="onGroupSelected(fieldGroup, $event.value)">
                      <mat-option [value]="null">Sin Grupo</mat-option>
                      <mat-option *ngFor="let group of currentGroups" [value]="group._id">
                        <mat-icon *ngIf="group.icon" class="mr-2 align-middle" [style.color]="group.iconColor || 'inherit'">
                          {{ group.icon }}
                        </mat-icon>
                        <span>{{ group.name }}</span>
                      </mat-option>
                    </mat-select>
                    <mat-hint>La posición, el ícono y el color se configuran en Gestionar Grupos.</mat-hint>
                  </mat-form-field>
                  <mat-form-field class="w-full sm:col-span-3">
                    <mat-label>Orden Campo</mat-label>
                    <input matInput type="number" min="1" formControlName="position" />
                    <mat-error *ngIf="fieldGroup.get('position')?.hasError('required')">La posición es requerida</mat-error>
                    <mat-error *ngIf="fieldGroup.get('position')?.hasError('min')">La posición debe ser 1 o mayor.</mat-error>
                    <mat-hint *ngIf="getPositionOccupantLabel(fieldGroup) as occupant">
                      Posición ocupada por {{ occupant }}; al guardar se recorrerá el resto.
                    </mat-hint>
                  </mat-form-field>
                </app-form-section>

                <app-form-section
                  title="Condicionales"
                  icon="settings"
                  iconColor="orange"
                  contentClass="grid grid-cols-1 gap-4 sm:grid-cols-2 md:grid-cols-3"
                >
                  <mat-form-field class="w-full">
                    <mat-label>Schema</mat-label>
                    <input matInput formControlName="schemaMaster" />
                  </mat-form-field>

                  <ng-container [ngSwitch]="fieldGroup.get('type').value">
                    <ng-container *ngSwitchCase="'multiselect'">
                      <mat-form-field
                        *ngIf="!fieldGroup.get('schemaMaster')?.value"

                        class="w-full"
                      >
                        <mat-label>Valores por Defecto (Múltiple)</mat-label>
                        <mat-select formControlName="defaultValue" multiple>
                          <mat-option *ngFor="let opt of fieldGroup.get('valuesData').value" [value]="opt.id">
                            {{ opt.name || opt.label || opt.id }}
                          </mat-option>
                        </mat-select>
                      </mat-form-field>
                      <app-select-schema
                        *ngIf="fieldGroup.get('schemaMaster')?.value"
                        class="w-full"
                        [schema]="fieldGroup.get('schemaMaster')?.value"
                        [form]="fieldGroup"
                        [isMultiple]="true"
                        [companyId]="data.companyId"
                      ></app-select-schema>
                    </ng-container>

                    <ng-container *ngSwitchCase="'select'">
                      <mat-form-field
                        *ngIf="!fieldGroup.get('schemaMaster')?.value"

                        class="w-full"
                      >
                        <mat-label>Valor por Defecto</mat-label>
                        <mat-select formControlName="defaultValue">
                          <mat-option [value]="''">Ninguno</mat-option>
                          <mat-option *ngFor="let opt of fieldGroup.get('valuesData').value" [value]="opt.id">
                            {{ opt.name || opt.label || opt.id }}
                          </mat-option>
                        </mat-select>
                      </mat-form-field>
                      <app-select-schema
                        *ngIf="fieldGroup.get('schemaMaster')?.value"
                        class="w-full"
                        [schema]="fieldGroup.get('schemaMaster')?.value"
                        [form]="fieldGroup"
                        [isMultiple]="false"
                        [companyId]="data.companyId"
                      ></app-select-schema>
                    </ng-container>

                    <mat-form-field *ngSwitchDefault class="w-full">
                      <mat-label>Valor por Defecto</mat-label>
                      <input matInput formControlName="defaultValue" />
                    </mat-form-field>
                  </ng-container>

                  <mat-form-field class="w-full">
                    <mat-label>Máx Char</mat-label>
                    <input matInput type="number" formControlName="maxLength" />
                  </mat-form-field>
                  <mat-form-field class="w-full">
                    <mat-label>Mín Char</mat-label>
                    <input matInput type="number" formControlName="minLength" />
                    <mat-error *ngIf="fieldGroup.get('minLength').hasError('minGreaterThanMax')">
                      El mínimo no puede ser mayor que el máximo.
                    </mat-error>
                  </mat-form-field>
                  <mat-form-field class="w-full">
                    <mat-label>Campo Padre</mat-label>
                    <input matInput formControlName="parentFieldName" />
                  </mat-form-field>
                  <mat-form-field *ngIf="fieldGroup.get('type').value === 'text'" class="w-full">
                    <mat-label>Conversión de Texto</mat-label>
                    <mat-select formControlName="caseConversion">
                      <mat-option value="NONE">Ninguno</mat-option>
                      <mat-option value="UPPER">Mayúsculas</mat-option>
                      <mat-option value="LOWER">Minúsculas</mat-option>
                      <mat-option value="TITLE">Capitalizar palabras</mat-option>
                      <mat-option value="SENTENCE">Capitalizar primera</mat-option>
                    </mat-select>
                  </mat-form-field>
                  <mat-form-field *ngIf="fieldGroup.get('type').value === 'text'" class="w-full">
                    <mat-label>Máscara de Texto</mat-label>
                    <input matInput formControlName="mask" placeholder="Ej. (000) 000-000" />
                  </mat-form-field>
                </app-form-section>

                <app-form-section
                  title="Configuración"
                  icon="settings"
                  iconColor="indigo"
                  contentClass="grid grid-cols-1 gap-4 sm:grid-cols-2"
                >
                  <app-toggle-option
                    title="Visible"
                    icon="visibility"
                    iconColor="blue"
                    formControlName="visible"
                  ></app-toggle-option>
                  <app-toggle-option
                    title="Requerido"
                    icon="lock"
                    iconColor="orange"
                    formControlName="required"
                  ></app-toggle-option>
                  <app-toggle-option
                    title="Mandatorio"
                    icon="gavel"
                    iconColor="red"
                    formControlName="isTypeMandatory"
                  ></app-toggle-option>
                  <app-toggle-option
                    title="Solo lectura"
                    icon="edit_off"
                    iconColor="purple"
                    formControlName="readOnly"
                  ></app-toggle-option>
                  <app-toggle-option
                    *ngIf="fieldGroup.get('type').value === 'text'"
                    class="sm:col-span-2"
                    title="Eliminar espacios"
                    icon="content_cut"
                    iconColor="green"
                    formControlName="trimSpaces"
                  ></app-toggle-option>
                </app-form-section>
              </div>
            </div>
          </div>
        </ng-container>
      </mat-dialog-content>

      <div class="flex justify-end gap-3 border-t bg-white p-4">
        <button mat-button (click)="closeEditModal()">Cancelar</button>
        <button
          mat-flat-button
          class="rounded-xl px-6 py-2 bg-green-600 text-white hover:bg-green-700 disabled:opacity-50"
          type="button"
          (click)="confirmFieldEdit()"
          [disabled]="
            getFieldControls(entities[selectedEntityIndex], selectedAction)[editingFieldIndex]?.invalid
            || isSavingCatalogForSelectedEntity
          "
        >
          {{ isSavingCatalogForSelectedEntity ? 'Guardando...' : 'Guardar' }}
        </button>
      </div>
    </div>
  </ng-template>
</div>
